/* 
 Created on : 10-Sept-2022, 22:08:00
 Author     : m.hanif.fahyuananto
 */

import store from "../store";

class TabelDinamisStoreV3 {
    /*local storage */

    getSelectionLocalStorageKey() {
        let x = {
            subject: "TabelDinamisSubjectOptions",
            dataset: "TabelDinamisDatasetOptions",
            indicator: "TabelDinamisIndicatorOptions",
            period: "TabelDinamisPeriodOptions",
            dimension: "TabelDinamisDimensionOptions",
            regionChild: "TabelDinamisRegionChildOptions",
        };

        return x;
    }

    updateSelectionLocalStorage(type, items, additional) {
        switch (type) {
            case "subject":
                {
                    let x = {
                        expiredDateTime: new Date(
                            new Date().getTime() +
                            60 * 60 * 1000
                        ).toString(),
                        items: items,
                    };

                    localStorage.setItem(this.getSelectionLocalStorageKey().subject, JSON.stringify(x));

                    break;
                }

            case "dataset":
                {
                    let x = {
                        expiredDateTime: new Date(
                            new Date().getTime() +
                            60 * 60 * 1000
                        ).toString(),
                        subjectName: additional.subjectName,
                        subjectId: additional.subjectId,
                        items: items,
                    };

                    let y = JSON.parse(this.getSelectionLocalStorageByKey("dataset"));

                    let z = y.filter(item => item.subjectId !== additional.subjectId);
                    z.push(x); //double guard

                    localStorage.setItem(this.getSelectionLocalStorageKey().dataset, JSON.stringify(z));

                    break;
                }

            case "indicator":
                {
                    let x = {
                        expiredDateTime: new Date(
                            new Date().getTime() +
                            60 * 60 * 1000
                        ).toString(),
                        datasetName: additional.datasetName,
                        datasetId: additional.datasetId,
                        items: items,
                    };

                    let y = JSON.parse(this.getSelectionLocalStorageByKey("indicator"));

                    let z = y.filter(item => item.datasetId !== additional.datasetId);
                    z.push(x); //double guard

                    localStorage.setItem(this.getSelectionLocalStorageKey().indicator, JSON.stringify(z));

                    break;
                }

            case "period":
                {
                    let x = {
                        expiredDateTime: new Date(
                            new Date().getTime() +
                            60 * 60 * 1000
                        ).toString(), //45 minutes because it updated rarely
                        datasetName: additional.datasetName,
                        datasetId: additional.datasetId,
                        items: items,
                    };

                    let y = JSON.parse(this.getSelectionLocalStorageByKey("period"));

                    let z = y.filter(item => item.datasetId !== additional.datasetId);
                    z.push(x); //double guard

                    localStorage.setItem(this.getSelectionLocalStorageKey().period, JSON.stringify(z));

                    break;
                }

            case "dimension":
                {
                    let x = {
                        expiredDateTime: new Date(
                            new Date().getTime() +
                            60 * 60 * 1000
                        ).toString(), //45 minutes because it updated rarely
                        datasetName: additional.datasetName,
                        datasetId: additional.datasetId,
                        items: items,
                    };

                    let y = JSON.parse(this.getSelectionLocalStorageByKey("dimension"));

                    let z = y.filter(item => item.datasetId !== additional.datasetId);
                    z.push(x); //double guard

                    localStorage.setItem(this.getSelectionLocalStorageKey().dimension, JSON.stringify(z));

                    break;
                }

            case "regionChild":
                {
                    let x = {
                        expiredDateTime: new Date(
                            new Date().getTime() +
                            60 * 60 * 1000
                        ).toString(), //45 minutes because it updated rarely
                        datasetName: additional.datasetName,
                        datasetId: additional.datasetId,
                        dimensionName: additional.dimensionName,
                        dimensionId: additional.dimensionId,
                        parentRegionName: additional.parentRegionName,
                        parentRegionId: additional.parentRegionId,
                        items: items,
                    };

                    let y = JSON.parse(this.getSelectionLocalStorageByKey("regionChild"));

                    let z = y.findIndex(item => {
                        return (item.datasetId === additional.datasetId && item.dimensionId === additional.dimensionId && item.parentRegionId === additional.parentRegionId)
                    });

                    if (z > -1) {
                        y.splice(z);
                    } //double guard

                    y.push(x);

                    localStorage.setItem(this.getSelectionLocalStorageKey().regionChild, JSON.stringify(y));

                    break;
                }
        }
    }

    getSelectionLocalStorageByKey(key) {
        return localStorage.getItem(
            this.getSelectionLocalStorageKey()[key]
        );
    }

    clearAllSelectionLocalStorage() {
        localStorage.removeItem(this.getSelectionLocalStorageKey().subject);
        localStorage.removeItem(this.getSelectionLocalStorageKey().dataset);
        localStorage.removeItem(this.getSelectionLocalStorageKey().indicator);
        localStorage.removeItem(this.getSelectionLocalStorageKey().period);
        localStorage.removeItem(this.getSelectionLocalStorageKey().dimension);
        localStorage.removeItem(this.getSelectionLocalStorageKey().regionChild);
    }

    /*specific local storage by object */
    /* subject */
    initializeSubjectOptionsLocalStorage() {
        return {
            expiredDateTime: "",
            items: [],
        };
    }

    initializeCategoryOptionsLocalStorage() {
        return {
            expiredDateTime: "",
            items: [],
        };
    }

    precheckSubjectOptionsLocalStorage() {
        let x = this.getSelectionLocalStorageByKey("subject");

        if (x == null) {
            let y =
                this.initializeSubjectOptionsLocalStorage();

            localStorage.setItem(this.getSelectionLocalStorageKey().subject, JSON.stringify(y));

            return "not-set";

        } else {
            let y = JSON.parse(x);

            if (y.expiredDateTime !== "" && y.items.length > -1) {
                let expiredDateTime = new Date(
                    y.expiredDateTime
                );

                let nowDateTime = new Date();

                if (expiredDateTime < nowDateTime) {
                    let z = this.initializeSubjectOptionsLocalStorage();
                    localStorage.setItem(this.getSelectionLocalStorageKey().subject, JSON.stringify(z));

                    return "expired";
                } else {
                    return "alive";
                }
            }else{
                return "expired";
            }
        }
    }

     precheckCategoryOptionsLocalStorage() {
        let x = this.getSelectionLocalStorageByKey("category");

        if (x == null) {
            let y =
                this.initializeCategoryOptionsLocalStorage();

            localStorage.setItem(this.getSelectionLocalStorageKey().subject, JSON.stringify(y));

            return "not-set";

        } else {
            let y = JSON.parse(x);

            if (y.expiredDateTime !== "" && y.items.length > -1) {
                let expiredDateTime = new Date(
                    y.expiredDateTime
                );

                let nowDateTime = new Date();

                if (expiredDateTime < nowDateTime) {
                    let z = this.initializeCategoryOptionsLocalStorage();
                    localStorage.setItem(this.getSelectionLocalStorageKey().category, JSON.stringify(z));

                    return "expired";
                } else {
                    return "alive";
                }
            }else{
                return "expired";
            }
        }
    }

    /* dataset */
    initializeDatasetOptionsLocalStorage() {
        return [];
    }

    precheckDatasetOptionsLocalStorage(subjectId) {
        let x = this.getSelectionLocalStorageByKey("dataset");

        if (x == null) {
            let y =
                this.initializeDatasetOptionsLocalStorage();

            localStorage.setItem(this.getSelectionLocalStorageKey().dataset, JSON.stringify(y));

            return "not-set";

        } else {
            let y = JSON.parse(x);

            this.cleaningDatasetOptionsLocalStorageExceptSelectedSubject(y, subjectId)

            let a = this.getSelectionLocalStorageByKey("dataset");
            let b = JSON.parse(a);
            let z = b.findIndex(item => item.subjectId === subjectId);

            if (z < 0) {
                return "not-set";
            } else {
                if (b[z].expiredDateTime !== "" && b[z].items.length > -1) {
                    let expiredDateTime = new Date(
                        b[z].expiredDateTime
                    );

                    let nowDateTime = new Date();

                    if (expiredDateTime < nowDateTime) {
                        b.splice(z);

                        localStorage.setItem(this.getSelectionLocalStorageKey().dataset, JSON.stringify(b));

                        return "expired";
                    } else {
                        return "alive";
                    }

                }
            }

        }
    }

    cleaningDatasetOptionsLocalStorageExceptSelectedSubject(y, subjectId) {
        let temp = [];
        let nowDateTime = new Date();

        y.forEach(item1 => {
            if (item1.subjectId === subjectId) {
                temp.push(item1);
            } else {
                if (item1.expiredDateTime !== "") {
                    let expiredDateTime = new Date(item1.expiredDateTime);

                    if (expiredDateTime >= nowDateTime) {
                        temp.push(item1);
                    }
                }
            }
        });

        localStorage.setItem(this.getSelectionLocalStorageKey().dataset, JSON.stringify(temp));
    }

    /* indicator */
    initializeIndicatorOptionsLocalStorage() {
        return [];
    }

    precheckIndicatorOptionsLocalStorage(datasetId) {
        let x = this.getSelectionLocalStorageByKey("indicator");

        if (x == null) {
            let y =
                this.initializeIndicatorOptionsLocalStorage();

            localStorage.setItem(this.getSelectionLocalStorageKey().indicator, JSON.stringify(y));

            return "not-set";

        } else {
            let y = JSON.parse(x);

            this.cleaningIndicatorOptionsLocalStorageExceptSelectedDataset(y, datasetId);

            let a = this.getSelectionLocalStorageByKey("indicator");
            let b = JSON.parse(a);
            let z = b.findIndex(item => item.datasetId === datasetId);

            if (z < 0) {
                return "not-set";
            } else {
                if (b[z].expiredDateTime !== "" && b[z].items.length > -1) {
                    let expiredDateTime = new Date(
                        b[z].expiredDateTime
                    );

                    let nowDateTime = new Date();

                    if (expiredDateTime < nowDateTime) {
                        b.splice(z);

                        localStorage.setItem(this.getSelectionLocalStorageKey().dataset, JSON.stringify(b));

                        return "expired";
                    } else {
                        return "alive";
                    }

                }
            }

        }
    }

    cleaningIndicatorOptionsLocalStorageExceptSelectedDataset(y, datasetId) {
        let temp = [];
        let nowDateTime = new Date();

        y.forEach(item1 => {
            if (item1.datasetId === datasetId) {
                temp.push(item1);
            } else {
                if (item1.expiredDateTime !== "") {
                    let expiredDateTime = new Date(item1.expiredDateTime);

                    if (expiredDateTime >= nowDateTime) {
                        temp.push(item1);
                    }
                }
            }
        });

        localStorage.setItem(this.getSelectionLocalStorageKey().indicator, JSON.stringify(temp));
    }

    /* period */
    initializePeriodOptionsLocalStorage() {
        return [];
    }

    precheckPeriodOptionsLocalStorage(datasetId) {
        let x = this.getSelectionLocalStorageByKey("period");

        if (x == null) {
            let y =
                this.initializePeriodOptionsLocalStorage();

            localStorage.setItem(this.getSelectionLocalStorageKey().period, JSON.stringify(y));

            return "not-set";

        } else {
            let y = JSON.parse(x);

            this.cleaningPeriodOptionsLocalStorageExceptSelectedDataset(y, datasetId)

            let a = this.getSelectionLocalStorageByKey("period");
            let b = JSON.parse(a);
            let z = b.findIndex(item => item.datasetId === datasetId);

            if (z < 0) {
                return "not-set";
            } else {
                if (b[z].expiredDateTime !== "" && b[z].items.length > -1) {
                    let expiredDateTime = new Date(
                        b[z].expiredDateTime
                    );

                    let nowDateTime = new Date();

                    if (expiredDateTime < nowDateTime) {
                        b.splice(z);

                        localStorage.setItem(this.getSelectionLocalStorageKey().period, JSON.stringify(b));

                        return "expired";
                    } else {
                        return "alive";
                    }

                }
            }

        }
    }

    cleaningPeriodOptionsLocalStorageExceptSelectedDataset(y, datasetId) {
        let temp = [];
        let nowDateTime = new Date();

        y.forEach(item1 => {
            if (item1.datasetId === datasetId) {
                temp.push(item1);
            } else {
                if (item1.expiredDateTime !== "") {
                    let expiredDateTime = new Date(item1.expiredDateTime);

                    if (expiredDateTime >= nowDateTime) {
                        temp.push(item1);
                    }
                }
            }
        });

        localStorage.setItem(this.getSelectionLocalStorageKey().period, JSON.stringify(temp));
    }

    /* dimension */
    initializeDimensionOptionsLocalStorage() {
        return [];
    }

    precheckDimensionOptionsLocalStorage(datasetId) {
        let x = this.getSelectionLocalStorageByKey("dimension");

        if (x == null) {
            let y =
                this.initializeDimensionOptionsLocalStorage();

            localStorage.setItem(this.getSelectionLocalStorageKey().dimension, JSON.stringify(y));

            return "not-set";

        } else {
            let y = JSON.parse(x);

            this.cleaningDimensionOptionsLocalStorageExceptSelectedDataset(y, datasetId)

            let a = this.getSelectionLocalStorageByKey("dimension");
            let b = JSON.parse(a);
            let z = b.findIndex(item => item.datasetId === datasetId);

            if (z < 0) {
                return "not-set";
            } else {
                if (b[z].expiredDateTime !== "" && b[z].items.length > -1) {
                    let expiredDateTime = new Date(
                        b[z].expiredDateTime
                    );

                    let nowDateTime = new Date();

                    if (expiredDateTime < nowDateTime) {
                        b.splice(z);

                        localStorage.setItem(this.getSelectionLocalStorageKey().dimension, JSON.stringify(b));

                        return "expired";
                    } else {
                        return "alive";
                    }

                }
            }

        }
    }

    cleaningDimensionOptionsLocalStorageExceptSelectedDataset(y, datasetId) {
        let temp = [];
        let nowDateTime = new Date();

        y.forEach(item1 => {
            if (item1.datasetId === datasetId) {
                temp.push(item1);
            } else {
                if (item1.expiredDateTime !== "") {
                    let expiredDateTime = new Date(item1.expiredDateTime);

                    if (expiredDateTime >= nowDateTime) {
                        temp.push(item1);
                    }
                }
            }
        });

        localStorage.setItem(this.getSelectionLocalStorageKey().dimension, JSON.stringify(temp));
    }

    /* child region */
    initializeRegionChildOptionsLocalStorage() {
        return [];
    }

    precheckRegionChildOptionsLocalStorage(datasetId, dimensionId, parentRegionId) {
        let x = this.getSelectionLocalStorageByKey("regionChild");

        if (x == null) {
            let y =
                this.initializeRegionChildOptionsLocalStorage();

            localStorage.setItem(this.getSelectionLocalStorageKey().regionChild, JSON.stringify(y));

            return "not-set";

        } else {
            let y = JSON.parse(x);

            this.cleaningRegionChildOptionsLocalStorageExceptSelectedDatasetDimensionParentRegion(y, datasetId, dimensionId, parentRegionId)

            let a = this.getSelectionLocalStorageByKey("regionChild");
            let b = JSON.parse(a);
            let z = b.findIndex(item => (item.datasetId === datasetId && item.dimensionId === dimensionId && item.parentRegionId === parentRegionId));

            if (z < 0) {
                return "not-set";
            } else {
                if (b[z].expiredDateTime !== "" && b[z].items.length > -1) {
                    let expiredDateTime = new Date(
                        b[z].expiredDateTime
                    );

                    let nowDateTime = new Date();

                    if (expiredDateTime < nowDateTime) {
                        b.splice(z, 1);

                        localStorage.setItem(this.getSelectionLocalStorageKey().regionChild, JSON.stringify(b));


                        return "expired";
                    } else {
                        return "alive";
                    }

                }
            }

        }
    }

    cleaningRegionChildOptionsLocalStorageExceptSelectedDatasetDimensionParentRegion(y, datasetId, dimensionId, parentRegionId) {
        let temp = [];
        let nowDateTime = new Date();

        y.forEach(item1 => {

            if (item1.datasetId === datasetId && item1.dimensionId === dimensionId && item1.parentRegionId === parentRegionId) {
                temp.push(item1);
            } else {
                if (item1.expiredDateTime !== "") {
                    let expiredDateTime = new Date(item1.expiredDateTime);

                    if (expiredDateTime >= nowDateTime) {
                        temp.push(item1);
                    }
                }
            }
        });

        localStorage.setItem(this.getSelectionLocalStorageKey().regionChild, JSON.stringify(temp));

    }

    /* selected data list */
    getSelectedDataListLocalStorage() {
        return localStorage.getItem("TabelDinamisSelectedDataList");
    }

    getSelectedDataListLocalStorageByCurrentUsername() {
        let selectedDataListLocalStorage = JSON.parse(this.getSelectedDataListLocalStorage());

        if (selectedDataListLocalStorage == null) {
            return null
        } else {
            let username = store.getters["auth/user"].username;
            return selectedDataListLocalStorage.filter(item => item.username === username);
        }

    }

    updateNewSelectedDataListLocalStorageByCurrentUsername(val) {
        let username = store.getters["auth/user"].username;
        let selectedDataListLocalStorage = JSON.parse(this.getSelectedDataListLocalStorage());
        let index = selectedDataListLocalStorage.findIndex(item => item.username === username);

        selectedDataListLocalStorage[index].items.push(val);

        localStorage.setItem("TabelDinamisSelectedDataList", JSON.stringify(selectedDataListLocalStorage));
    }

    updateNewSelectedDataListLocalStorageByCurrentUsernameAndItemIndex(val, index) {
        let username = store.getters["auth/user"].username;
        let selectedDataListLocalStorage = JSON.parse(this.getSelectedDataListLocalStorage());
        let idx = selectedDataListLocalStorage.findIndex(item => item.username === username);

        selectedDataListLocalStorage[idx].items[index] = val;

        localStorage.setItem("TabelDinamisSelectedDataList", JSON.stringify(selectedDataListLocalStorage));
    }

    insertNewSelectedDataListLocalStorageByCurrentUsername(val) {
        let username = store.getters["auth/user"].username;
        let selectedDataListLocalStorage = JSON.parse(this.getSelectedDataListLocalStorage());
        let y = {
            username: username,
            items: [val]
        };
        if (selectedDataListLocalStorage == null) {
            selectedDataListLocalStorage = [];
        }
        selectedDataListLocalStorage.push(y);

        localStorage.setItem("TabelDinamisSelectedDataList", JSON.stringify(selectedDataListLocalStorage));
    }

    clearAllSelectedDataListLocalStorageByCurrentUsername() {
        let username = store.getters["auth/user"].username;
        let selectedDataListLocalStorage = JSON.parse(this.getSelectedDataListLocalStorage());
        let idx = selectedDataListLocalStorage.findIndex(item => item.username === username);

        selectedDataListLocalStorage[idx].items = [];

        localStorage.setItem("TabelDinamisSelectedDataList", JSON.stringify(selectedDataListLocalStorage));
    }

    clearSelectedDataListLocalStorageByCurrentUsername(index) {
        let username = store.getters["auth/user"].username;
        let selectedDataListLocalStorage = JSON.parse(this.getSelectedDataListLocalStorage());
        let idx = selectedDataListLocalStorage.findIndex(item => item.username === username);

        selectedDataListLocalStorage[idx].items.splice(index, 1);

        localStorage.setItem("TabelDinamisSelectedDataList", JSON.stringify(selectedDataListLocalStorage));
    }
}

export default new TabelDinamisStoreV3();
/* keep in mind, remove local storage when it's expired */